import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import setTitle from "../../../components/common/SetTitle";
import LoadingSpinner from "../../../components/loadingSpinner/LoadingSpinner";
import { OutletIProps } from "../../../components/sitebase/Base.types";
import InlineFeatureMap from "./components/InlineFeatureMap";
import { InlineNotification, InlinePaginatedResponse } from "./Inline.types";
import { INLINE_MENU_LINKS } from './InlineMenu';

/**
 * Shows the matched features of all INLINE notifications on a single map.
 */
export function InlineMap() {
    const { setExtraMenuLinks } = useOutletContext<OutletIProps>();
    const [loading, setLoading] = useState<boolean>(true);
    const [matchedFeatures, setMatchedFeatures] = useState<string[]>([]);

    useEffect(() => {
        setTitle("INLINE Map");
        setExtraMenuLinks(INLINE_MENU_LINKS, "Map");
    }, [setExtraMenuLinks]);

    useEffect(() => {
        setLoading(true);
        fetch("/api/inline/notifications/?format=json&active=all&historical=all&page_size=1000", { credentials: "include" })
            .then(async (response) => {
                const data = await response.json().catch(() => null);
                if (!response.ok) {
                    const message = data?.message || data?.detail || JSON.stringify(data) || "Unknown error";
                    throw new Error(`HTTP ${response.status}: ${message}`);
                }
                return data as InlinePaginatedResponse<InlineNotification>;
            })
            .then((data) => {
                setMatchedFeatures((data?.results || []).map((notification) => notification.matched_feature));
            })
            .catch((error) => {
                console.error("Failed to load INLINE notifications:", error);
                toast.error(`Failed to load notifications: ${error instanceof Error ? error.message : String(error)}`);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="container-fluid py-3">
            <ToastContainer position="top-center" />
            {loading ? (
                <LoadingSpinner />
            ) : (
                <InlineFeatureMap matched_features={matchedFeatures} />
            )}
        </div>
    );
}
